/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import _sliceInstanceProperty from"@babel/runtime-corejs3/core-js-stable/instance/slice";import isNumber from"./isNumber";import isString from"./isString";import isUndefined from"./isUndefined";const truncate=function(e,r,i){isString(e)||(e=`${e}`),r=isNumber(r)?r:30,i=isUndefined(i)?"...":i;let t=r<0?0:r;return e.length>r?_sliceInstanceProperty(e).call(e,0,t)+i:String(e)};export default truncate;